import type { TimeWindow } from '@bilmat/shared';

/** Tolerans runt målvärdet. Flyttas till inställningsvyn när den finns. */
export const EAT_TOLERANCE_MIN = 30;

/** Sliderns steg och tak. */
export const EAT_STEP_MIN = 15;
export const EAT_TARGET_MAX_MIN = 240;

/** Sliderns maxvärde: restiden uppåtavrundad till kvart, minst ett steg, tak 240. */
export function eatTargetMax(totalMin: number): number {
  const quarter = Math.ceil(totalMin / EAT_STEP_MIN) * EAT_STEP_MIN;
  return Math.max(EAT_STEP_MIN, Math.min(EAT_TARGET_MAX_MIN, quarter));
}

/**
 * Härleder sökfönstret ur målvärdet: mål ± tolerans, klampat till [0, restid].
 * targetMin 0 = "så snart som möjligt" → fönstret [0, min(restid, 30)].
 */
export function deriveTimeWindow(targetMin: number, totalMin: number): TimeWindow {
  return {
    earliestMin: Math.max(0, targetMin - EAT_TOLERANCE_MIN),
    latestMin: Math.min(totalMin, targetMin + EAT_TOLERANCE_MIN),
  };
}
